import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CompanyRole } from '@/services/ws-permissions/src/main/resources/rest-api';
import { PermissionType } from '@/js/libs/generated/permissions/types';
import { AGENCY_ROLES } from './constants';
import { useTokenStorage } from './hooks';
import { CombinedRole } from './types';
const AuthContext = React.createContext({});
const AuthProvider = ({ children }) => {
    const { getAuthToken } = useTokenStorage();
    const [token, setToken] = React.useState(getAuthToken);
    const [identity, setIdentity] = React.useState({
        user: undefined,
        loading: false,
        initialized: false,
    });
    const identityRoles = React.useMemo(() => {
        const user = identity?.user;
        if (!user?.id) {
            return [PermissionType.ANONYMOUS];
        }
        const isAgencyRelatedRoles = user.company.companyRole === CompanyRole.ADMIN || AGENCY_ROLES.some((role) => user.permissions?.includes(role));
        const isPublisher = user.company.companyRole === CompanyRole.ADMIN || user.permittedWebsiteIds.length > 0;
        return [
            user.userRole,
            user.company.companyRole,
            ...(user.permissions || []),
            ...(isPublisher ? [CombinedRole.PUBLISHER] : []),
            ...(isAgencyRelatedRoles ? [CombinedRole.AGENCY] : []),
        ].filter((role) => !!role);
    }, [identity]);
    const value = React.useMemo(() => ({
        identity,
        setIdentity,
        identityRoles,
        token,
        setToken,
    }), [identity, setIdentity, identityRoles, token, setToken]);
    return _jsx(AuthContext.Provider, { value: value, children: children });
};
export { AuthContext, AuthProvider };
